// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"d814057a","194":"345cc1b6","199":"d84883ae","348":"345cc1b6","580":"6ab39138","782":"345cc1b6","985":"345cc1b6"}[chunkId] + ".chunk.css";
};